module.exports = __webpack_public_path__ + "img/promenada2_map.8ab924d7.jpg";